// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1QlMG","left":"InfoRow_left__1gh4z"};